// @ts-nocheck
(() => {
  const selector = 'video[data-tv-lazy-video]';

  const loadVideo = (video) => {
    if (!video || video.dataset.tvLazyVideoState === 'loaded') return;
    video.dataset.tvLazyVideoState = 'loaded';

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    video.load();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.autoplay = false;
      video.controls = true;
      return;
    }

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  };

  const init = (root = document) => {
    const videos = [...root.querySelectorAll(selector)].filter(
      (video) => !video.dataset.tvLazyVideoObserved
    );
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(loadVideo);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          loadVideo(entry.target);
        });
      },
      { rootMargin: '300px 0px', threshold: 0.01 }
    );

    videos.forEach((video) => {
      video.dataset.tvLazyVideoObserved = 'true';
      observer.observe(video);
    });
  };

  if (window.TrueVitalsLazyVideo) {
    window.TrueVitalsLazyVideo.init(document);
    return;
  }

  window.TrueVitalsLazyVideo = { init, loadVideo };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
